module.exports = __webpack_public_path__ + "img/close.bbbc62ad.png";